module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "smooth-appear",
      rawName: "v-smooth-appear",
      value: ({
        elements: '.smooth-appear'
      }),
      expression: "{elements: '.smooth-appear'}"
    }],
    staticClass: "root"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h1', {
    staticClass: "title smooth-appear"
  }, [_vm._v("\n      Vladimir Verstoff\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub smooth-appear"
  }, [_vm._v("\n      Web Developer\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "location smooth-appear"
  }, [_c('icon', {
    attrs: {
      "name": "location"
    }
  }), _vm._v("\n      RUSSIA, SIBERIA, 54\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "experience smooth-appear"
  }, [_vm._v("\n      4 year's experience\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, [_c('skills-list', {
    staticClass: "skills__category",
    attrs: {
      "items": _vm.skills[0]
    }
  }), _vm._v(" "), _c('skills-list', {
    staticClass: "skills__category",
    attrs: {
      "items": _vm.skills[1]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "projects"
  }, [_c('project-list', {
    attrs: {
      "items": _vm.projects
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "contact smooth-appear"
  }, [_c('ui-button', {
    staticClass: "contact__button",
    attrs: {
      "href": "mailto:contact@verstoff.ru",
      "target": "_blank"
    }
  }, [_vm._v("\n        CONTACT\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links smooth-appear"
  }, _vm._l((_vm.socials), function(url, network) {
    return _c('a', {
      key: network,
      staticClass: "social-link",
      attrs: {
        "href": url,
        "target": "_blank"
      }
    }, [_c('icon', {
      staticClass: "social-link__icon",
      attrs: {
        "name": network,
        "height": "30",
        "width": "auto"
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6da3d88a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 157
// module chunks = 1